import { TaskName } from '@/common/constants/taskNames.constants';
import { TaskState } from '@schema';

const getInitialState = () => ({
  config: {
    last_backup_date: null,
    last_backup_location: null,
    ready: false,
    tasks: []
  }
});

export default {
  name: 'managementNodeBackup',
  namespaced: true,
  state: getInitialState(),
  getters: {
    config: state => state.config
  },
  mutations: {
    SET_CONFIG(state, config) {
      state.config = config;
    },
    FLUSH_STATE(state) {
      Object.assign(state, getInitialState());
    },
  },
  actions: {
    FETCH_CONFIG({ commit }) {
      return this.$api.get('/api/v2/backup').then(({ data }) => {
        commit('SET_CONFIG', data);
      });
    },
    BACKUP_NOW() {
      return this.$api.post('/api/v2/backup');
    },
    socket_tasks({ dispatch }, { name, state }) {
      if (name === TaskName.MANAGEMENT_NODE_BACKUP && state === TaskState.SUCCESS) {
        dispatch('FETCH_CONFIG');
      }
    }
  }
};
